import LittleNavigation from "../components/LittleNavigation"; 
const SubHero = ({imgUrl, section, name, destination}) => {
  return (
    <>
        <div className = "grid grid-cols-1 items-end bg-cover bg-no-repeat bg-center relative h-[15rem] sm:h-[20rem] bg-gray-300 text-white" style={{backgroundImage:`url(${imgUrl})`}}>
              <LittleNavigation  section = {section} name = {name} destination = {destination}/>
        </div>

    </>

  ); 
}
export default SubHero; 
